import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getOperatingInstructionLabels(context) {
    return axios
      .get("operatingInstructionLabel")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
      });
  },

  createOperatingInstructionLabel(context, value) {
    return axios
      .post("operatingInstructionLabel", value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteOperatingInstructionLabel(context, val) {
    return axios
      .delete("operatingInstructionLabel/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.deletedMessage")
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateOperatingInstructionLabel(context, value) {
    return axios
      .put("operatingInstructionLabel/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.updatedMessage", { name: r.data.name })
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  moveOperatingInstructionLabel(context, { id, instructionCategory }) {
    return axios
      .put(`operatingInstructionLabel/${id}`, { instructionCategory })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.movedMessage", {
            name: r.data.name,
          })
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getSingleOperatingInstructionLabel(context, id) {
    return axios
      .get("operatingInstructionLabel/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfOperatingInstructionLabel(context, id) {
    return axios
      .get("operatingInstructionLabel/" + id + "/pdf")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
